module.exports = __webpack_public_path__ + "media/images/webpage/hotels/9494/plan1-3-c1a437946d267a1be42ffd0fe5af612d.webp";